/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Administration {

    @Serenity.Decorators.registerClass()
    export class UserGrid extends NoboxEntityGrid<UserRow, any> {
        protected getColumnsKey() { return Administration.UserColumns.columnsKey; }
        protected getDialogType() { return UserDialog; }
        protected getIdProperty() { return UserRow.idProperty; }
        protected getIsActiveProperty() { return UserRow.isActiveProperty; }
        protected getLocalTextPrefix() { return UserRow.localTextPrefix; }
        protected getService() { return UserService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            var q = Q.parseQueryString();
            if (q["active"]) {
                var activeFl = this.findQuickFilter(ActvEditor, "IsActive")
                activeFl.value = q["active"];
            }
            if (q["country"]) {
                var countryFl = this.findQuickFilter(Serenity.ServiceLookupEditor, UserRow.Fields.CtryId)
                countryFl.value = q["country"];
            }
            if (q["role"]) {
                var roleFl = this.findQuickFilter(Serenity.LookupEditor, UserRow.Fields.Roles)
                roleFl.value = q["role"];
            }
        }
        protected getQuickFilters() {
            var flt = super.getQuickFilters();

            flt.push({
                type: ActvEditor,
                field: 'IsActive',
                title: 'IsActive',
                handler: w => {
                    (this.view.params as TenantListRequest).EqualityFilter.IsActive = Q.toId(w.value);
                },
                cssClass: 'hidden-xs'
            });
            return flt;
        }
        protected getColumns() {
            var columns = super.getColumns();

            var impersonate = Q.tryFirst(columns, x => x.field == "ImpersonationToken");
            if (impersonate != null) {
                impersonate.format = ctx => {
                    if (!ctx.value)
                        return "";

                    return `<a target="_blank" href="${Q.resolveUrl('~/Account/ImpersonateAs?token=')}${ctx.value}">`
                        + `<i class="fa fa-user-secret text-blue"></i></a>`;
                };
            }
            Q.first(columns, x => x.field == UserRow.Fields.TnNm).format =
                ctx => {
                    return `<a href="javascript:;" class="tenant-link">${Q.htmlEncode(ctx.value)}</a>`;
                };
            Q.first(columns, x => x.field == UserRow.Fields.Ctry).format =
                    ctx => `<a href="javascript:;" class="ctry-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == UserRow.Fields.States).format =
                ctx => `<a href="javascript:;" class="stt-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == UserRow.Fields.City).format =
                ctx => `<a href="javascript:;" class="cty-link">${Q.htmlEncode(ctx.value)}</a>`;
            var roles = Q.tryFirst(columns, x => x.field == UserRow.Fields.Roles);
            if (roles) {
                roles.format = ctx => {
                    var roleList = (ctx.value || []).map(x => (RoleRow.getLookup().itemById[x] || {}).RoleName || "");
                    roleList.sort();
                    return roleList.join(", ");
                };
            }

            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            var countryFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                UserRow.Fields.CtryId);
            var stateFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                UserRow.Fields.StatesId);
            var cityFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                UserRow.Fields.CityId);
            if (target.hasClass("tenant-link")) {
                e.preventDefault();
                new TenantDialog().loadByIdAndOpenDialog(item.TenantId);
            } else if (target.hasClass("ctry-link")) {
                e.preventDefault();
;
                countryFilter.set_value(item.CtryId.toString());
                Q.notifySuccess("Success filter by country")
                this.refresh();
            } else if (target.hasClass("stt-link")) {
                e.preventDefault();

                countryFilter.set_value(item.CtryId.toString());
                stateFilter.set_value(item.StatesId.toString());
                Q.notifySuccess("Success filter by city");
                this.refresh();
            } else if (target.hasClass("cty-link")) {
                e.preventDefault();

                countryFilter.set_value(item.CtryId.toString());
                stateFilter.set_value(item.StatesId.toString());
                cityFilter.set_value(item.CityId.toString());
                Q.notifySuccess("Success filter by state");
                this.refresh();
            }
        }
    }
}